var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse2, _ellipse3, _circle2, _circle3, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji44(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 17,
    cy: 19,
    r: 17
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664500",
    cx: 17.999,
    cy: 26,
    rx: 2,
    ry: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M8.111 21.383c-.182 0-.367-.05-.532-.154-.467-.294-.607-.911-.313-1.379.916-1.453 3.701-3.938 7.69-2.962.536.131.864.673.733 1.209-.132.536-.676.862-1.209.733-3.604-.882-5.502 2.056-5.521 2.086-.191.302-.516.467-.848.467zm11.973-3.742c-.29 0-.576-.125-.774-.366-.35-.427-.288-1.058.14-1.408 3.176-2.604 6.762-1.562 8.215-.646.467.294.607.912.312 1.379-.293.465-.908.607-1.376.315-.138-.084-3.052-1.823-5.884.499-.186.153-.41.227-.633.227z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2A62D",
    d: "M13.346 31.273c-.068 0-.137-.009-.205-.028-.398-.113-.63-.527-.517-.926.437-1.54.258-3.029-.49-4.086-.497-.702-1.205-1.131-1.943-1.178-.414-.025-.728-.382-.702-.795s.381-.751.795-.701c1.193.074 2.313.733 3.073 1.807 1.011 1.429 1.27 3.383.709 5.361-.093.331-.394.546-.72.546zm11.037-3.061c-.142 0-.285-.04-.412-.124-1.167-.77-1.82-2.117-1.792-3.695.029-1.635.809-3.153 1.984-3.869.353-.216.814-.104 1.03.251.216.354.104.814-.251 1.03-.735.448-1.244 1.499-1.264 2.614-.02 1.055.389 1.936 1.118 2.417.346.228.441.693.213 1.039-.144.219-.382.337-.626.337z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2E44",
    d: "M17.179 2.72c-.043-.049-.11-.076-.189-.091 0 0-15.924-3.023-16.613-2.415C-.311.823.74 16.998.74 16.998c.005.081.023.15.067.199.604.684 4.758-2.004 9.279-6.001 4.522-3.998 7.697-7.792 7.093-8.476z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M.349.271C.334.301.321.342.311.394.47 1.765 2.006 13.046 2.963 16.572c1.436-.803 2.895-1.894 4.609-3.253C6.116 10.654 1.158.146.349.271z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B88C3",
    d: "M29.902 29.229l-10.573-1.303c-1.13-.102-3.117-.112-3.015-1.902.093-1.623 2.04-1.373 3.479-1.16l10.638 1.774-.529 2.591z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C9F9",
    d: "M30.43 26.639l-4.222-.724c-.494-.089-.934.647-.956 1.426-.025.866.227 1.304.726 1.406l4.144.512.308-2.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B88C3",
    d: "M34.918 26.341l-2.622 2.411-4.687-5.097 2.622-2.411c1.361-1.252 3.499-1.162 4.751.199l.135.147c1.251 1.362 1.162 3.499-.199 4.751z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.597 29.954 26.205)",
    fill: "#88C9F9",
    cx: 29.952,
    cy: 26.203,
    rx: 2.77,
    ry: 3.462
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.597 29.954 26.205)",
    fill: "#269",
    cx: 29.952,
    cy: 26.203,
    rx: 1.385,
    ry: 2.077
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#55ACEE",
    cx: 2.5,
    cy: 33.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#55ACEE",
    cx: 29,
    cy: 2,
    r: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M4.864 29.246L2.526 23.63.412 29.675zM26 5l-4 1 1-4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#77B255",
    d: "M31.999 13L36 7.999 33 6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji44);
export default __webpack_public_path__ + "static/media/emoji44.ea54191208d770b20952253e96bdf941.svg";
export { ForwardRef as ReactComponent };